export default "__VITE_ASSET__CPieIFxD__"